module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/bookcase/bookTexture3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/bookcase/bookTexture3.jpg
// module id = 523
// module chunks = 0